module.exports = __webpack_public_path__ + "img/standup-sit.24a7a23c.svg";